__turbopack_context__.v({
  "card": "index-module-scss-module__xnOZgq__card",
});
